import React from "react";

import { useFormikContext } from "formik";
import { SourceEnum } from "../../../../../enums/template";
import { Template } from "../../../../../models";
import TemplateContainer from "../../common/TemplateContainer";
import AdditionalContextInput from "./AdditionalContextInput";
import CreativityLevelSelector, {
  useCreativityLevelSupported,
} from "./CreativityLevelSelector";
import IncludeCreditsToggle from "./IncludeCreditsToggle";
import TranscribeSubjectSelector from "./TranscribeSubjectSelector";

const AdditionalSettings = () => {
  const { values } = useFormikContext<Partial<Template>>();
  const isTopItemsArticle = values.sourceId === SourceEnum.TOP_ITEMS;
  const isBestItemsArticle = values.sourceId === SourceEnum.BEST_ITEMS;
  const showContextFields = !isTopItemsArticle && !isBestItemsArticle;
  const showCreativityLevel = useCreativityLevelSupported();

  return (
    <div className="space-y-6 animate-fadeIn">
      <TemplateContainer>
        <IncludeCreditsToggle />
      </TemplateContainer>
      {(showContextFields || showCreativityLevel) && (
        <TemplateContainer className="flex flex-col gap-0">
          {showContextFields && (
            <>
              <AdditionalContextInput />
              <TranscribeSubjectSelector />
            </>
          )}
          {showCreativityLevel && <CreativityLevelSelector />}
        </TemplateContainer>
      )}
    </div>
  );
};

export default AdditionalSettings;
